exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sun-editor-editable td p,import \"suneditor/dist/css/suneditor.min.css\"{margin:0}.content ul{margin-left:0!important}.content table td,.content table th{border-width:1px!important}.help-outside{position:fixed;top:0;left:0;right:0;bottom:0;z-index:120;background:rgba(0,0,0,.3)}.help-desc{position:fixed;z-index:125;top:120px;left:300px;background-color:#fff;border-radius:4px;width:490px;padding:20px;font-size:14px;white-space:pre-line}.help-sub-desc{color:#666;margin-top:4px;margin-bottom:12px}", ""]);

// exports
